<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";   
import apigeneric from "@/helpers/apigeneric";
import Loader from "@/components/widgets/loader";
import Banner from "../components/banner";

export default {
  page: {
    title: process.env.VUE_APP_NAME,
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Loader,
    Banner

  },
  mixins: [ apigeneric],
  data() {
    return {
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      title: this.$t('StrAnasayfa.Title'),
      NewsData:{},
      NewsTitleDescription: {},
      NewsTitle: {},
      ReadMoreValue: {},
      LangId: this.$route.params.LangId,
      items: [
         
        {
          text: this.$t('StrAnasayfa.Title'),
          active: true,
        },
      ],  
      fetchingStats: true,  
    };
  }, 
  methods: { 
    getFirstImage(gallery) {
      if (gallery && typeof gallery === 'string' && gallery.trim() !== '') {
        return gallery.split(',')[0].trim();
      }
      return '';
    },
    handleImgError(e) {
      e.target.style.display = 'none';
      if (e.target.parentElement) {
        const fallback = e.target.parentElement.querySelector('.img-fallback-icon');
        if (fallback) fallback.style.display = 'flex';
      }
    },
    Get(){
      if(this.LangId=="tr" || this.LangId== null){
        this.ActionsFilterGet({
        Service: "News",
        Page: this.Page,
        Filter:
       "&Newstype=2&Websiteid="+window.$cookies.get("ecampuswebsite"),
      }).then((res) => {
        this.NewsData = res.Data; 
            this.Page.PageDataSize = res.TotalCount;
      });
    }else{
      this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
       "&shortlangtitle="+ this.LangId
      }).then((res) => {
        for( let LangData in res.Data){
          this.ActionsFilterGet({
        Service: "newstranslations",
        Page: this.Page,
        Filter: "&Langid="+ res.Data[LangData].Id
      }).then((res) => {
        this.NewsData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
        if(res.TotalCount == 0){
              localStorage.setItem("lang", "tr");
              window.location.reload();
              
            }
        
      });
         }
        
      });
     
    }


    this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
          "&shortlangtitle=" + this.LangId
      }).then((res) => {
        for (let LangData in res.Data) {
          this.ActionsFilterGet({
            Service: "LanguagereSources",
            Page: this.Page,
            Filter: "&Langid=" + res.Data[LangData].Id + "&Resourceid=0d5e3dfc-5021-466e-9385-e05926007b30"
          }).then((res) => {
            this.NewsTitle = res.Data;
            if (res.TotalCount == 0) {
              localStorage.setItem("lang", "tr");
              window.location.reload();
            }
          });
        }
      });


      this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
          "&shortlangtitle=" + this.LangId
      }).then((res) => {
        for (let LangData in res.Data) {
          this.ActionsFilterGet({
            Service: "LanguagereSources",
            Page: this.Page,
            Filter: "&Langid=" + res.Data[LangData].Id + "&Resourceid=717cda32-6f7d-42a8-9c26-97ad3e5c0aed"
          }).then((res) => {
            this.NewsTitleDescription = res.Data;
            if (res.TotalCount == 0) {
              localStorage.setItem("lang", "tr");
              window.location.reload();
            }
          });
        }
      });

      this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
          "&shortlangtitle=" + this.LangId
      }).then((res) => {
        for (let LangData in res.Data) {
          this.ActionsFilterGet({
            Service: "LanguagereSources",
            Page: this.Page,
            Filter: "&Langid=" + res.Data[LangData].Id + "&Resourceid=878b315b-fa05-41b1-9cc5-4c480effbf65"
          }).then((res) => {
            this.ReadMoreValue = res.Data;
            if (res.TotalCount == 0) {
              localStorage.setItem("lang", "tr");
              window.location.reload();
            }
          });
        }
      });
    }
  },
};
</script>

<template>
 <Loader>
  <Layout> 
      <Banner />
     
<section>
        <div class="home-news">
            <div class="title c-flex flex-column">
                <h3>{{NewsTitle[0].Resourcevalue}}</h3>
                <p>{{NewsTitleDescription[0].Resourcevalue}}</p> 
            </div> 
            <div class="container">
                    <div class="row align-items-stretch">
                          <div
            class="col-md-4 mb-4 d-flex align-items-stretch"
            v-for="(Data, index) in NewsData"
            :key="index"
          >
            <div class="card w-100 d-flex flex-column">
              <div class="card-img-wrapper">
                <img
                  v-if="getFirstImage(Data.Imagegallery)"
                  :src="$config.FILES_URL + 'web/' + getFirstImage(Data.Imagegallery)"
                  class="card-img-top"
                  alt=""
                  @error="handleImgError"
                />
                <div class="img-fallback-icon" :style="{ display: getFirstImage(Data.Imagegallery) ? 'none' : 'flex' }">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="#ffffff" opacity="0.85" viewBox="0 0 16 16">
                    <path d="M0 2.5A1.5 1.5 0 0 1 1.5 1h11A1.5 1.5 0 0 1 14 2.5v10.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 13V2.5zM1.5 2a.5.5 0 0 0-.5.5v10.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V2.5a.5.5 0 0 0-.5-.5h-11z"/>
                    <path d="M3 4h8v1H3V4zm0 3h8v1H3V7zm0 3h5v1H3v-1z"/>
                  </svg>
                </div>
              </div>
              <div class="card-body d-flex flex-column flex-grow-1">
                <h5 class="card-date">{{ Data.Startdate | formatDateTime }}</h5>
                <h5 class="card-title mt-3">
                  {{ Data.Title }}
                </h5>
                <p class="card-text flex-grow-1">
                  <span v-html="Data.Description"></span><br/>
                </p>
                <a :href="'/NewsDetail/'+ LangId + '/'+ Data.Title.toLowerCase()
                                    .replace(/I|İ/gi, 'i')
                                    .replace(/Ğ|ğ/gi, 'g')
                                    .replace(/Ç|ç|ğ/gi, 'c')
                                    .replace(/\s+/g, '-')
                                    .replace(/&/g, `-and-`)
                                    .replace(/--/g, `-`) + '/'+ Data.Id" class="card-link mt-auto"
                  >{{ReadMoreValue[0].Resourcevalue}} →</a
                >
               
              </div>
            </div>
          </div>
                      </div>
            </div>
            <b-pagination
                class="pagination pagination-rounded justify-content-end mb-2"
                v-model="DefaultPage"
                :total-rows="Page.PageDataSize"
                :per-page="Page.PageSize"
                aria-controls="my-table"
                @input="ChangePage(DefaultPage)"
              >
              </b-pagination>
        </div>
    </section>



     
  
  </Layout>
  </Loader>
</template>

<style scoped>
.home-news .card {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.home-news .card .card-body {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
}
.home-news .card .card-body .card-text {
  flex-grow: 1;
}
.home-news .card .card-body .card-link {
  margin-top: auto;
}
.card-img-wrapper {
  width: 100%;
  height: 200px;
  background-color: #00758f;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.home-news .card .card-img-top {
  width: 100%;
  height: 200px;
  object-fit: contain;
  background-color: #00758f;
}
.img-fallback-icon {
  width: 100%;
  height: 100%;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00758f;
}
</style>
